import Rating from "@mui/material/Rating";
import React, { useCallback, useEffect, useState } from "react";
import { BsSquareFill } from "react-icons/bs";
import { Cell, Pie, PieChart, ResponsiveContainer, Sector } from "recharts";
const renderActiveShape = (props, type) => {
  const RADIAN = Math.PI / 180;
  const {
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    startAngle,
    endAngle,
    fill,
    payload,
    percent,
    value,
  } = props;
  const sin = Math.sin(-RADIAN * midAngle);
  const cos = Math.cos(-RADIAN * midAngle);
  const sx = cx + (outerRadius + 10) * cos;
  const sy = cy + (outerRadius + 10) * sin;
  const mx = cx + (outerRadius + 30) * cos;
  const my = cy + (outerRadius + 30) * sin;
  const ex = mx + (cos >= 0 ? 1 : -1) * 22;
  const ey = my;
  const textAnchor = cos >= 0 ? "start" : "end";

  function truncate(source, size) {
    return source.length > size ? source.slice(0, size - 1) + "…" : source;
  }

  return (
    <g>
      <text x={cx} y={cy} dy={8} textAnchor="middle" width={10} fill={fill}>
        {type === "score" ? (
          <>{payload.name} Yıldız</>
        ) : (
          <>{truncate(payload.name, 13)}</>
        )}
      </text>
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fill}
      />
      <Sector
        cx={cx}
        cy={cy}
        startAngle={startAngle}
        endAngle={endAngle}
        innerRadius={outerRadius + 6}
        outerRadius={outerRadius + 10}
        fill={fill}
      />
      {window.innerWidth > 800 ? (
        <>
          <path
            d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`}
            stroke={fill}
            fill="none"
          />
          <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none" />
          <text
            x={ex + (cos >= 0 ? 1 : -1) * 12}
            y={ey}
            textAnchor={textAnchor}
            fill="#333"
          >{` ${value}`}</text>
          <text
            x={ex + (cos >= 0 ? 1 : -1) * 12}
            y={ey}
            dy={18}
            textAnchor={textAnchor}
            fill="#999"
          >
            {`( ${(percent * 100).toFixed(2)}%)`}
          </text>
        </>
      ) : (
        ""
      )}
    </g>
  );
};

export default function PieCharts({ emoji, data, type }) {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isEmoji, setIsEmoji] = useState(false);
  useEffect(() => {
    setIsEmoji(emoji === true);
  }, [emoji]);

  const onPieEnter = useCallback(
    (_, index) => {
      setActiveIndex(index);
    },
    [setActiveIndex]
  );
  const COLORS = [
    "#0088FE",
    "#00C49F",
    "#FFBB28",
    "#FF8042",
    "#F38181",
    "#F94892",
    "#3D8361",
    "#7FBCD2",
    "#277BC0",
    "#42032C",
    "#D36B00",
    "#319DA0",
    "#1CD6CE",
  ];

  const processedData = data.map((element) => {
    if (isEmoji) {
      if (element.name === "yes") {
        return { ...element, name: "Evet" }; // "yes" ise emoji :)
      } else if (element.name === "no") {
        return { ...element, name: "Hayır" }; // "no" ise emoji :(
      }
    }
    return element; // Aksi takdirde orijinal değeri döndür
  });

  return (
    <>
      <div className="flex  items-center justify-center  p-1">
        <div className="items-start justify-start flex-col p-1 md:flex hidden w-full overflow-hidden">
          {processedData.map((element, index) => (
            <div className="flex w-full" key={index}>
              <div className="flex items-center m-1 w-full overflow-hidden">
                <BsSquareFill fill={COLORS[index % COLORS.length]} size={15} />

                {type === "score" ? (
                  <Rating
                    size="small"
                    readOnly
                    value={parseInt(element.name)}
                  />
                ) : (
                  ""
                )}

                <div className="ml-2 text-[14px] truncate max-w-[100px]">{element.name}</div>
                <div className="ml-2 text-[14px] mr-2 truncate max-w-[60px]">({element.value})</div>
              </div>
            </div>
          ))}
        </div>

        <div className="md:ml-10">
          <ResponsiveContainer
            width={window.innerWidth > 800 ? 500 : 200}
            height={400}
          >
            <PieChart>
              <Pie
                dataKey="value"
                startAngle={0}
                endAngle={360}
                data={processedData}
                cx="50%"
                cy="50%"
                activeIndex={activeIndex}
                activeShape={(e) => renderActiveShape(e, type)}
                innerRadius={60}
                outerRadius={80}
                fill="#fd1"
                onMouseEnter={onPieEnter}
              >
                {processedData.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={COLORS[index % COLORS.length]}
                    values={entry.value + entry.name}
                  />
                ))}
              </Pie>
            </PieChart>
          </ResponsiveContainer>
        </div>
      </div>
    </>
  );
}
